import React from 'react';
import { renderIcon } from '../SprintDetail/FlowchartView/utils/renderIcon';

/**
 * DocSkeleton — optimistic loading state for a doc surface.
 *
 * Prefer `bodyOnly` when the host already renders real icon/title chrome
 * (LibraryDocPane) so those elements never remount and cannot shift.
 */
const LINE_WIDTHS = [92, 100, 64, 0, 88, 97, 42, 0, 100, 76, 91, 30];

/**
 * `variant`: 'pane' matches LibraryDocPane (40px icon, 24px title);
 * 'fullpage' matches DocFullPage (52px icon, 30px title). The host
 * container owns width/padding — the skeleton just fills it, so the real
 * content doesn't shift when it swaps in.
 */
const DocSkeleton = ({ meta, variant = 'pane', bodyOnly = false }) => (
  <div
    className={`doc-skeleton doc-skeleton--${variant}${bodyOnly ? ' doc-skeleton--body-only' : ''}`}
    aria-hidden="true"
  >
    {!bodyOnly && (
      <>
        <div className="doc-skeleton__icon">
          {meta?.icon != null ? (
            renderIcon(meta.icon, {
              size: variant === 'fullpage' ? '52px' : '40px',
              fallback: <span>📄</span>,
            })
          ) : (
            <div className="doc-skeleton__icon-ph doc-skeleton__shimmer" />
          )}
        </div>
        {meta?.title ? (
          <h1 className="doc-skeleton__title">{meta.title}</h1>
        ) : (
          <div className="doc-skeleton__title-ph doc-skeleton__shimmer" />
        )}
      </>
    )}
    <div className="doc-skeleton__body">
      {LINE_WIDTHS.map((w, i) =>
        w === 0 ? (
          <div key={i} className="doc-skeleton__gap" />
        ) : (
          <div
            key={i}
            className="doc-skeleton__line doc-skeleton__shimmer"
            style={{ width: `${w}%`, animationDelay: `${i * 0.06}s` }}
          />
        )
      )}
    </div>
  </div>
);

export default DocSkeleton;
